import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloseIcon from "@material-ui/icons/Close";
import api from "../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 600,
    margin: "80px auto 40px",
    padding: theme.spacing(4),
    borderRadius: 16,
    background: "#fff",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
  },

  dropzone: {
    border: "2px dashed #2563eb",
    padding: theme.spacing(4),
    textAlign: "center",
    borderRadius: 16,
    color: "#2563eb",
    cursor: "pointer",
    marginTop: theme.spacing(3),
    transition: "0.25s",
    "&:hover": {
      background: "#eef5ff",
      borderColor: "#1d4ed8",
      transform: "scale(1.02)",
    },
  },

  previewBox: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    borderRadius: 16,
    background: "#fafafa",
    border: "1px solid #ddd",
    textAlign: "center",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
    position: "relative",
  },

  closeBtn: {
    position: "absolute",
    top: 8,
    right: 8,
    background: "#fff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    "&:hover": {
      background: "#f0f0f0",
    },
  },

  enviarBtn: {
    marginTop: theme.spacing(4),
    background: "#2563eb",
    color: "#fff",
    fontWeight: 600,
    borderRadius: 50,
    padding: theme.spacing(1.7),
    width: "100%",
    "&:hover": { background: "#1d4ed8" },
  },

  iconUpload: {
    fontSize: 50,
    marginBottom: theme.spacing(1),
    animation: `$fadeIn 0.3s ease`,
  },

  "@keyframes fadeIn": {
    "0%": { opacity: 0, transform: "scale(0.8)" },
    "100%": { opacity: 1, transform: "scale(1)" },
  },
}));

export default function StatusPage() {
  const classes = useStyles();

  const [text, setText] = useState("");
  const [caption, setCaption] = useState("");
  const [fileBase64, setFileBase64] = useState(null);
  const [fileType, setFileType] = useState("");

  // ==========================
  // Conversão p/ Base64
  // ==========================
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setText("");      // apaga texto
    setCaption("");   // apaga legenda

    const reader = new FileReader();
    reader.onloadend = () => {
      setFileBase64(reader.result);
      setFileType(file.type);
    };

    reader.readAsDataURL(file);
  };

  // ==========================
  // Enviar Status
  // ==========================
  const enviarStatus = async () => {
    try {
      const payload = {};

      // TEXT
      if (!fileBase64 && text.trim()) {
        payload.text = text.trim();
      }

      // MIDIA
      if (fileBase64) {
        if (fileType.startsWith("image")) payload.image = fileBase64;
        if (fileType.startsWith("video")) payload.video = fileBase64;
        if (fileType.startsWith("audio")) payload.audio = fileBase64;

        if (caption.trim()) payload.caption = caption.trim();
      }

      if (!payload.text && !fileBase64) {
        return toast.error("Envie texto ou mídia!");
      }

      await api.post("/status/enviar", payload);

      toast.success("Status enviado com sucesso!");

      // RESET
      setText("");
      setCaption("");
      setFileBase64(null);
      setFileType("");

    } catch (err) {
      console.error(err);
      toast.error("Erro ao enviar status!");
    }
  };

  return (
    <Paper className={classes.container}>
      <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 20 }}>
        📣 Enviar Status do WhatsApp
      </Typography>

      {/* CAMPO TEXTO ou LEGENDA */}
      {!fileBase64 ? (
        <TextField
          label="Texto do status"
          variant="outlined"
          fullWidth
          multiline
          rows={2}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      ) : (
        <TextField
          label="Legenda da mídia (opcional)"
          variant="outlined"
          fullWidth
          multiline
          rows={2}
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
      )}

      {/* DROPZONE */}
      <Box
        className={classes.dropzone}
        onClick={() => document.getElementById("input-file").click()}
      >
        <CloudUploadIcon className={classes.iconUpload} />
        <Typography style={{ fontSize: 15, fontWeight: 600 }}>
          Clique para anexar imagem, vídeo ou áudio
        </Typography>
      </Box>

      <input
        id="input-file"
        type="file"
        accept="image/*,video/*,audio/*"
        style={{ display: "none" }}
        onChange={handleFile}
      />

      {/* PREVIEW */}
      {fileBase64 && (
        <Box className={classes.previewBox}>
          <IconButton
            className={classes.closeBtn}
            onClick={() => {
              setFileBase64(null);
              setFileType("");
              setCaption("");
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="subtitle1" style={{ marginBottom: 10 }}>
            Pré-visualização:
          </Typography>

          {fileType.startsWith("image") && (
            <img src={fileBase64} alt="preview" style={{ maxWidth: "100%", borderRadius: 10 }} />
          )}

          {fileType.startsWith("video") && (
            <video controls style={{ maxWidth: "100%", borderRadius: 10 }}>
              <source src={fileBase64} />
            </video>
          )}

          {fileType.startsWith("audio") && (
            <audio controls style={{ width: "100%" }}>
              <source src={fileBase64} />
            </audio>
          )}
        </Box>
      )}

      <Button className={classes.enviarBtn} onClick={enviarStatus}>
        Enviar Status
      </Button>
    </Paper>
  );
}
